// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, User, CheckCircle, Wallet, Send, Copy, ArrowLeft, Shield, Zap, DollarSign } from 'lucide-react';
// import '../../Dashboard Style/WalletTransfer.css';
// import { useSelector } from 'react-redux';

// const WalletTransfer = () => {
//   const navigate = useNavigate();
//   const [activeMode, setActiveMode] = useState('active-id'); // 'active-id' or 'send-money'
//   const [availableAmount] = useState(1500.75); // Main wallet amount
//   const [activeEmail, setActiveEmail] = useState('');
//   const [sendEmail, setSendEmail] = useState('');
//   const [customAmount, setCustomAmount] = useState('');
//   const [searching, setSearching] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [searchResult, setSearchResult] = useState(null);
//   const [accountName, setAccountName] = useState('');
//   const [apiError, setApiError] = useState('');
//   const [transferring, setTransferring] = useState(false);
//   const authToken = useSelector((state) => state.user?.token);

//   // Add openDropdowns state
//   const [openDropdowns, setOpenDropdowns] = useState({});

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality (same as in Dashboard)
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');
    
//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }
    
//     // Add custom scrollbar to sidebar body
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     // Initialize dropdowns as closed
//     const initialDropdownState = {
//       dashboard: false,
//       fundManagement: false,
//       registrationTeam: false,
//       incomeEarnings: false,
//       bonanzaRewards: false,
//       airdrop: false,
//       withdrawal: false,
//       settings: false
//     };
//     setOpenDropdowns(initialDropdownState);

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Add custom scrollbar styles for sidebar
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }
      
//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }
      
//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }
      
//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }
      
//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }
      
//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }
      
//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }
      
//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }
      
//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }
      
//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }
      
//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   // Toggle dropdown function (for the Sidebar component)
//   const toggleDropdown = (key) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   // API call to search user by email
//   const searchUserByEmail = async (email) => {
//     try {
//       setSearching(true);
//       setApiError('');
      
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/get-user-by-email`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: new URLSearchParams({
//           email: email
//         })
//       });

//       const data = await response.json();
      
//       if (data.status) {
//         // User found successfully
//         setAccountName(data.data.account_name || 'User Found');
//         setSearchResult({
//           email: email,
//           name: data.data.account_name || email,
//           avatarColor: '#00d4aa',
//           verified: true
//         });
//         return { success: true, data: data.data };
//       } else {
//         // User not found or error
//         setSearchResult(null);
//         setAccountName('');
//         setApiError(data.message || 'User not found');
//         return { success: false, message: data.message };
//       }
//     } catch (error) {
//       console.error('Error searching user:', error);
//       setSearchResult(null);
//       setAccountName('');
//       setApiError('Failed to search user. Please try again.');
//       return { success: false, message: 'Network error' };
//     } finally {
//       setSearching(false);
//     }
//   };

//   const handleSearchActiveEmail = async () => {
//     if (!activeEmail.trim()) {
//       alert('Please enter an email address');
//       return;
//     }
    
//     await searchUserByEmail(activeEmail);
//   };

//   const handleSearchSendEmail = async () => {
//     if (!sendEmail.trim()) {
//       alert('Please enter an email address');
//       return;
//     }
    
//     await searchUserByEmail(sendEmail);
//   };

//   // API call for Active ID transfer ($5)
//   const handleActiveIdTransfer = async () => {
//     try {
//       setTransferring(true);
      
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/active-register-user-by-wallet`, {
//         method: 'POST',
//          headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: new URLSearchParams({
//           email: activeEmail
//         })
//       });

//       const data = await response.json();
      
//       if (data.status) {
//         alert('User activated successfully! $5 transferred.');
//         navigate('/dashboard');
//       } else {
//         alert(data.message || 'Transfer failed');
//       }
//     } catch (error) {
//       console.error('Error activating user:', error);
//       alert('Failed to activate user. Please try again.');
//     } finally {
//       setTransferring(false);
//     }
//   };

//   // API call for Send Money transfer (custom amount)
//   const handleSendMoneyTransfer = async () => {
//     try {
//       setTransferring(true);
      
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/sent-wallet`, {
//         method: 'POST',
//          headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: new URLSearchParams({
//           email: sendEmail,
//           wallet_type: 'FuelWallet', // Adjust this based on your requirements
//           amount: customAmount
//         })
//       });

//       const data = await response.json();
      
//       if (data.status) {
//         alert(`$${customAmount} sent successfully!`);
//         navigate('/dashboard');
//       } else {
//         alert(data.message || 'Transfer failed');
//       }
//     } catch (error) {
//       console.error('Error sending money:', error);
//       alert('Failed to send money. Please try again.');
//     } finally {
//       setTransferring(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (activeMode === 'active-id') {
//       if (!activeEmail.trim()) {
//         alert('Please enter recipient email');
//         return;
//       }
      
//       if (!searchResult) {
//         alert('Please search and verify the user first');
//         return;
//       }
      
//       if (window.confirm(`Send $5.00 to ${activeEmail}?`)) {
//         await handleActiveIdTransfer();
//       }
//     } else {
//       if (!sendEmail.trim() || !customAmount) {
//         alert('Please fill all fields');
//         return;
//       }
      
//       if (!searchResult) {
//         alert('Please search and verify the user first');
//         return;
//       }
      
//       const amount = parseFloat(customAmount);
//       if (amount > availableAmount) {
//         alert('Insufficient funds in your wallet');
//         return;
//       }
      
//       if (amount < 1) {
//         alert('Minimum transfer amount is $1');
//         return;
//       }
      
//       if (window.confirm(`Send $${amount.toFixed(2)} to ${sendEmail}?`)) {
//         await handleSendMoneyTransfer();
//       }
//     }
//   };

//   const handleCopyEmail = () => {
//     const email = activeMode === 'active-id' ? activeEmail : sendEmail;
//     if (email) {
//       navigator.clipboard.writeText(email);
//       alert('Email copied to clipboard!');
//     }
//   };

//   // Reset search when switching modes
//   const handleModeChange = (mode) => {
//     setActiveMode(mode);
//     setSearchResult(null);
//     setAccountName('');
//     setApiError('');
//     if (mode === 'active-id') {
//       setSendEmail('');
//     } else {
//       setActiveEmail('');
//     }
//   };

//   return (
//     <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar */}
//         <Navbar toggleSidebar={toggleSidebar} />

//         {/* Main Content */}
//         <div className="page-content">
//           <div className="wallet-transfer-container-dark">
//             <div className="container-fluid">
//               <div className="row justify-content-center">
//                 <div className="" style={{width:"100%"}}>
//                   {/* Main Card */}
//                   <div className="dark-transfer-card">
                 
//                     <div className="dark-balance-section">
//                       <div className="balance-card-dark">
//                         <div className="balance-content">
//                           <div className="balance-label-dark">My Wallet Balance</div>
//                           <div className="balance-amount-dark">${availableAmount.toFixed(2)}</div>
//                           <div className="balance-subtitle-dark">Quantum Main Vault • Ready to Transfer</div>
//                         </div>
//                         <div className="wallet-icon-dark">
//                           <Wallet size={40} />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Mode Toggle */}
//                     <div className="dark-mode-toggle">
//                       <div className="toggle-buttons-dark">
//                         <button
//                           className={`toggle-btn-dark ${activeMode === 'active-id' ? 'active' : ''}`}
//                           onClick={() => handleModeChange('active-id')}
//                         >
//                           <CheckCircle size={20} className="me-3" />
//                           <div className="toggle-content">
//                             <div className="toggle-title">Active ID Transfer</div>
//                             <div className="toggle-subtitle">Fixed $5 amount</div>
//                           </div>
//                         </button>
//                         <button
//                           className={`toggle-btn-dark ${activeMode === 'send-money' ? 'active' : ''}`}
//                           onClick={() => handleModeChange('send-money')}
//                         >
//                           <Send size={20} className="me-3" />
//                           <div className="toggle-content">
//                             <div className="toggle-title">Send Money</div>
//                             <div className="toggle-subtitle">Custom amount</div>
//                           </div>
//                         </button>
//                       </div>
//                     </div>

//                     {/* Form Section */}
//                     <div className="dark-form-section">
//                       <form onSubmit={handleSubmit}>
//                         {/* Email Search */}
//                         <div className="form-group-dark">
//                           <label className="form-label-dark">
//                             <Search size={18} className="me-2" />
//                             Search Recipient by Email
//                           </label>
//                           <div className="search-container-dark">
//                             <div className="input-group-dark">
//                               <div className="input-icon-dark">
//                                 <User size={18} />
//                               </div>
//                               <input
//                                 type="email"
//                                 className="dark-input"
//                                 placeholder="Enter recipient's email address"
//                                 value={activeMode === 'active-id' ? activeEmail : sendEmail}
//                                 onChange={(e) => {
//                                   if (activeMode === 'active-id') {
//                                     setActiveEmail(e.target.value);
//                                   } else {
//                                     setSendEmail(e.target.value);
//                                   }
//                                   setSearchResult(null);
//                                   setAccountName('');
//                                   setApiError('');
//                                 }}
//                                 required
//                               />
//                               <button
//                                 type="button"
//                                 className="copy-btn-dark"
//                                 onClick={handleCopyEmail}
//                                 disabled={!activeEmail && !sendEmail}
//                               >
//                                 <Copy size={16} />
//                               </button>
//                             </div>
//                             <button
//                               type="button"
//                               className="search-btn-dark"
//                               onClick={activeMode === 'active-id' ? handleSearchActiveEmail : handleSearchSendEmail}
//                               disabled={searching}
//                             >
//                               {searching ? (
//                                 <>
//                                   <span className="spinner-border spinner-border-sm me-2"></span>
//                                   Searching...
//                                 </>
//                               ) : (
//                                 <>
//                                   <Search size={16} className="me-2" />
//                                   Search
//                                 </>
//                               )}
//                             </button>
//                           </div>
//                           {apiError && (
//                             <div className="error-message-dark mt-2">
//                               {apiError}
//                             </div>
//                           )}
//                         </div>

//                         {/* Search Result */}
//                         {searchResult && (
//                           <div className="search-result-dark">
//                             <div className="account-name-display-dark">
//                               <div className="account-name-label">Account Name :</div>
//                               <div className="account-name-value">{accountName}</div>
//                             </div>
//                           </div>
//                         )}

//                         {/* Amount Section */}
//                         <div className="amount-section-dark">
//                           {activeMode === 'active-id' ? (
//                             <div className="fixed-amount-dark">
//                               <div className="fixed-amount-label">Fixed Transfer Amount</div>
//                               <div className="fixed-amount-value">$5.00</div>
//                               <div className="fixed-amount-note">Active ID transfer amount (Fixed)</div>
//                             </div>
//                           ) : (
//                             <div className="custom-amount-dark">
//                               <label className="custom-amount-label">Enter Amount to Transfer</label>
//                               <div className="amount-input-container">
//                                 <div className="amount-input-group-dark">
//                                   <span className="currency-symbol-dark">$</span>
//                                   <input
//                                     type="number"
//                                     className="amount-input-dark"
//                                     placeholder="0.00"
//                                     min="1"
//                                     max={availableAmount}
//                                     step="0.01"
//                                     value={customAmount}
//                                     onChange={(e) => setCustomAmount(e.target.value)}
//                                     required
//                                     disabled={!searchResult}
//                                   />
//                                   <span className="currency-label-dark">USD</span>
//                                 </div>
//                                 <div className="amount-limits-dark">
//                                   <span>Min: $1.00</span>
//                                   <span>Available: ${availableAmount.toFixed(2)}</span>
//                                   <span>Max: ${availableAmount.toFixed(2)}</span>
//                                 </div>
//                               </div>
//                             </div>
//                           )}
//                         </div>

//                         {/* Submit Button */}
//                         <div className="submit-section">
//                           <button 
//                             type="submit" 
//                             className="submit-btn-dark"
//                             disabled={!searchResult || (activeMode === 'send-money' && !customAmount) || transferring}
//                           >
//                             {transferring ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                 Processing...
//                               </>
//                             ) : (
//                               <>
//                                 <Send size={22} className="me-3" />
//                                 {activeMode === 'active-id' ? 'Transfer $5.00' : `Send $${customAmount || '0.00'}`}
//                               </>
//                             )}
//                           </button>
//                         </div>

//                         {/* Features */}
//                         <div className="features-section">
//                           <div className="row">
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon secure-feature">
//                                   <Shield size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Secure</div>
//                                   <div className="feature-desc">End-to-end encrypted</div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon fast-feature">
//                                   <Zap size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Instant</div>
//                                   <div className="feature-desc">Processed in seconds</div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon low-feature">
//                                   <DollarSign size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Low Fees</div>
//                                   <div className="feature-desc">Minimum charges</div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default WalletTransfer;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, User, CheckCircle, Wallet, Send, Copy, Shield, Zap, DollarSign } from 'lucide-react';
// import '../../Dashboard Style/WalletTransfer.css';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import {
//   searchUserByEmailApi,
//   activeRegisterUserByWalletApi,
//   sendWalletTransferApi,
//   getUserWalletBalanceApi
// } from '../../Services/Operations/ProductAPI'; // Import the APIs

// const WalletTransfer = () => {
//   const navigate = useNavigate();
//   const [activeMode, setActiveMode] = useState('active-id');
//   const [availableAmount, setAvailableAmount] = useState(0);
//   const [activeEmail, setActiveEmail] = useState('');
//   const [sendEmail, setSendEmail] = useState('');
//   const [customAmount, setCustomAmount] = useState('');
//   const [searching, setSearching] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [searchResult, setSearchResult] = useState(null);
//   const [accountName, setAccountName] = useState('');
//   const [apiError, setApiError] = useState('');
//   const [transferring, setTransferring] = useState(false);
//   const [loadingBalance, setLoadingBalance] = useState(true);
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');
    
//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }
    
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     return () => {};
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Add custom scrollbar styles for sidebar
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }
      
//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }
//     `;
//     document.head.appendChild(style);

//     // Fetch wallet balance on component mount
//     fetchWalletBalance();

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

  
//     useEffect(() => {
//       const style = document.createElement('style');
//       style.innerHTML = `
//         .sidebar-body {
//           height: calc(100vh - 70px);
//           overflow-y: auto;
//         }
        
//         .sidebar-body::-webkit-scrollbar {
//           width: 6px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-track {
//           background: rgba(255, 255, 255, 0.05);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb {
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb:hover {
//           background: rgba(255, 255, 255, 0.3);
//         }
        
//         .sidebar .nav-dropdown {
//           list-style: none;
//           padding-left: 0;
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//         }
        
//         .sidebar .nav-dropdown.show {
//           max-height: 500px;
//         }
        
//         .sidebar .nav-dropdown-item {
//           padding-left: 2.5rem;
//         }
        
//         .nav-item.has-dropdown .nav-link {
//           position: relative;
//           padding-right: 2.5rem;
//         }
        
//         .nav-item.has-dropdown .dropdown-icon {
//           position: absolute;
//           right: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           transition: transform 0.3s ease;
//         }
        
//         .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//           transform: translateY(-50%) rotate(180deg);
//         }
        
//         .nav-item.has-dropdown .nav-dropdown {
//           background: rgba(255, 255, 255, 0.05);
//           border-left: 3px solid var(--primary-color, #0d6efd);
//           margin-left: 1rem;
//           border-radius: 0 0 8px 8px;
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//           padding: 0.75rem 1rem 0.75rem 2rem;
//           color: rgba(255, 255, 255, 0.8);
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//           background: rgba(255, 255, 255, 0.1);
//           color: white;
//         }
        
//         .nav-item.has-dropdown .link-title.nav-item.nav-category {
//           font-weight: 600;
//           font-size: 0.875rem;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
        
//         .sidebar {
//           transition: all 0.3s ease;
//         }
//       `;
//       document.head.appendChild(style);
  
//       return () => {
//         document.head.removeChild(style);
//       };
//     }, []);

//   const fetchWalletBalance = async () => {
//     try {
//       setLoadingBalance(true);
      
//       // Get balance from user data or API
//       if (userData?.wallets?.main_wallet) {
//         setAvailableAmount(parseFloat(userData.wallets.main_wallet));
//       } else {
//         const result = await getUserWalletBalanceApi(authToken);
//         if (result.status) {
//           setAvailableAmount(parseFloat(result.data.main_wallet || result.data.balance || 0));
//         } else {
//           toast.error(result.message || 'Failed to load wallet balance');
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching wallet balance:', error);
//       toast.error('Failed to load wallet balance');
//     } finally {
//       setLoadingBalance(false);
//     }
//   };

//   const searchUserByEmail = async (email) => {
//     try {
//       setSearching(true);
//       setApiError('');
      
//       const result = await searchUserByEmailApi(authToken, email);
      
//       if (result.status) {
//         // User found successfully
//         const userData = result.data;
//         setAccountName(userData.account_name || userData.name || email);
//         setSearchResult({
//           email: email,
//           name: userData.account_name || userData.name || email,
//           accountName: userData.account_name,
//           userId: userData.id,
//           avatarColor: '#00d4aa',
//           verified: true
//         });
//         toast.success('User found successfully!');
//         return { success: true, data: userData };
//       } else {
//         // User not found or error
//         setSearchResult(null);
//         setAccountName('');
//         setApiError(result.message || 'User not found');
//         toast.error(result.message || 'User not found');
//         return { success: false, message: result.message };
//       }
//     } catch (error) {
//       console.error('Error searching user:', error);
//       setSearchResult(null);
//       setAccountName('');
//       setApiError('Failed to search user. Please try again.');
//       toast.error('Failed to search user. Please try again.');
//       return { success: false, message: 'Network error' };
//     } finally {
//       setSearching(false);
//     }
//   };

//   const handleSearchActiveEmail = async () => {
//     if (!activeEmail.trim()) {
//       toast.error('Please enter an email address');
//       return;
//     }
    
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(activeEmail)) {
//       toast.error('Please enter a valid email address');
//       return;
//     }
    
//     await searchUserByEmail(activeEmail);
//   };

//   const handleSearchSendEmail = async () => {
//     if (!sendEmail.trim()) {
//       toast.error('Please enter an email address');
//       return;
//     }
    
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(sendEmail)) {
//       toast.error('Please enter a valid email address');
//       return;
//     }
    
//     await searchUserByEmail(sendEmail);
//   };

//   const handleActiveIdTransfer = async () => {
//     try {
//       setTransferring(true);
      
//       const result = await activeRegisterUserByWalletApi(authToken, activeEmail);
      
//       if (result.status) {
//         toast.success(result.message || 'User activated successfully! $5 transferred.');
//         // Update wallet balance after transfer
//         fetchWalletBalance();
//         // Reset form
//         setActiveEmail('');
//         setSearchResult(null);
//         setAccountName('');
//         // Navigate after delay
//         setTimeout(() => {
//           navigate('/dashboard');
//         }, 2000);
//       } else {
//         toast.error(result.message || 'Transfer failed');
//       }
//     } catch (error) {
//       console.error('Error activating user:', error);
//       toast.error('Failed to activate user. Please try again.');
//     } finally {
//       setTransferring(false);
//     }
//   };

//   const handleSendMoneyTransfer = async () => {
//     try {
//       setTransferring(true);
      
//       const result = await sendWalletTransferApi(
//         authToken, 
//         sendEmail, 
//         'FuelWallet', // Adjust this based on your requirements
//         customAmount
//       );
      
//       if (result.status) {
//         toast.success(result.message || `$${customAmount} sent successfully!`);
//         // Update wallet balance after transfer
//         fetchWalletBalance();
//         // Reset form
//         setSendEmail('');
//         setCustomAmount('');
//         setSearchResult(null);
//         setAccountName('');
//         // Navigate after delay
//         setTimeout(() => {
//           navigate('/dashboard');
//         }, 2000);
//       } else {
//         toast.error(result.message || 'Transfer failed');
//       }
//     } catch (error) {
//       console.error('Error sending money:', error);
//       toast.error('Failed to send money. Please try again.');
//     } finally {
//       setTransferring(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (activeMode === 'active-id') {
//       if (!activeEmail.trim()) {
//         toast.error('Please enter recipient email');
//         return;
//       }
      
//       if (!searchResult) {
//         toast.error('Please search and verify the user first');
//         return;
//       }
      
//       // Show confirmation dialog
//       const confirmed = window.confirm(
//         `Are you sure you want to activate ${accountName}?\n\n` +
//         `Email: ${activeEmail}\n` +
//         `Amount: $5.00\n\n` +
//         `This action cannot be undone.`
//       );
      
//       if (confirmed) {
//         await handleActiveIdTransfer();
//       }
      
//     } else {
//       if (!sendEmail.trim() || !customAmount) {
//         toast.error('Please fill all fields');
//         return;
//       }
      
//       if (!searchResult) {
//         toast.error('Please search and verify the user first');
//         return;
//       }
      
//       const amount = parseFloat(customAmount);
//       if (amount > availableAmount) {
//         toast.error('Insufficient funds in your wallet');
//         return;
//       }
      
//       if (amount < 1) {
//         toast.error('Minimum transfer amount is $1');
//         return;
//       }
      
//       // Show confirmation dialog
//       const confirmed = window.confirm(
//         `Are you sure you want to send $${amount.toFixed(2)} to ${accountName}?\n\n` +
//         `Email: ${sendEmail}\n` +
//         `Amount: $${amount.toFixed(2)}\n` +
//         `Available: $${availableAmount.toFixed(2)}\n\n` +
//         `This action cannot be undone.`
//       );
      
//       if (confirmed) {
//         await handleSendMoneyTransfer();
//       }
//     }
//   };

//   const handleCopyEmail = () => {
//     const email = activeMode === 'active-id' ? activeEmail : sendEmail;
//     if (email) {
//       navigator.clipboard.writeText(email);
//       toast.success('Email copied to clipboard!');
//     }
//   };

//   const handleModeChange = (mode) => {
//     setActiveMode(mode);
//     setSearchResult(null);
//     setAccountName('');
//     setApiError('');
//     if (mode === 'active-id') {
//       setSendEmail('');
//       setCustomAmount('');
//     } else {
//       setActiveEmail('');
//     }
//   };

//   const formatAmount = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   return (
//     <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar */}
//         <Navbar toggleSidebar={toggleSidebar} />

//         {/* Main Content */}
//         <div className="page-content">
//           <div className="wallet-transfer-container-dark">
//             <div className="container-fluid">
//               <div className="row justify-content-center">
//                 <div className="" style={{width:"100%"}}>
//                   {/* Main Card */}
//                   <div className="dark-transfer-card">
//                     <div className="dark-balance-section">
//                       <div className="balance-card-dark">
//                         <div className="balance-content">
//                           <div className="balance-label-dark">My Wallet Balance</div>
//                           <div className="balance-amount-dark">
//                             {loadingBalance ? (
//                               <span className="spinner-border spinner-border-sm me-2"></span>
//                             ) : (
//                               `$${formatAmount(availableAmount)}`
//                             )}
//                           </div>
//                           <div className="balance-subtitle-dark">Quantum Main Vault • Ready to Transfer</div>
//                         </div>
//                         <div className="wallet-icon-dark">
//                           <Wallet size={40} />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Mode Toggle */}
//                     <div className="dark-mode-toggle">
//                       <div className="toggle-buttons-dark">
//                         <button
//                           className={`toggle-btn-dark ${activeMode === 'active-id' ? 'active' : ''}`}
//                           onClick={() => handleModeChange('active-id')}
//                           disabled={transferring}
//                         >
//                           <CheckCircle size={20} className="me-3" />
//                           <div className="toggle-content">
//                             <div className="toggle-title">Active ID Transfer</div>
//                             <div className="toggle-subtitle">Fixed $5 amount</div>
//                           </div>
//                         </button>
//                         <button
//                           className={`toggle-btn-dark ${activeMode === 'send-money' ? 'active' : ''}`}
//                           onClick={() => handleModeChange('send-money')}
//                           disabled={transferring}
//                         >
//                           <Send size={20} className="me-3" />
//                           <div className="toggle-content">
//                             <div className="toggle-title">Send Money</div>
//                             <div className="toggle-subtitle">Custom amount</div>
//                           </div>
//                         </button>
//                       </div>
//                     </div>

//                     {/* Form Section */}
//                     <div className="dark-form-section">
//                       <form onSubmit={handleSubmit}>
//                         {/* Email Search */}
//                         <div className="form-group-dark">
//                           <label className="form-label-dark">
//                             <Search size={18} className="me-2" />
//                             Search Recipient by Email
//                           </label>
//                           <div className="search-container-dark">
//                             <div className="input-group-dark">
//                               <div className="input-icon-dark">
//                                 <User size={18} />
//                               </div>
//                               <input
//                                 type="email"
//                                 className="dark-input"
//                                 placeholder="Enter recipient's email address"
//                                 value={activeMode === 'active-id' ? activeEmail : sendEmail}
//                                 onChange={(e) => {
//                                   if (activeMode === 'active-id') {
//                                     setActiveEmail(e.target.value);
//                                   } else {
//                                     setSendEmail(e.target.value);
//                                   }
//                                   setSearchResult(null);
//                                   setAccountName('');
//                                   setApiError('');
//                                 }}
//                                 required
//                                 disabled={transferring}
//                               />
//                               <button
//                                 type="button"
//                                 className="copy-btn-dark"
//                                 onClick={handleCopyEmail}
//                                 disabled={(!activeEmail && !sendEmail) || transferring}
//                                 title="Copy email"
//                               >
//                                 <Copy size={16} />
//                               </button>
//                             </div>
//                             <button
//                               type="button"
//                               className="search-btn-dark"
//                               onClick={activeMode === 'active-id' ? handleSearchActiveEmail : handleSearchSendEmail}
//                               disabled={searching || transferring}
//                             >
//                               {searching ? (
//                                 <>
//                                   <span className="spinner-border spinner-border-sm me-2"></span>
//                                   Searching...
//                                 </>
//                               ) : (
//                                 <>
//                                   <Search size={16} className="me-2" />
//                                   Search
//                                 </>
//                               )}
//                             </button>
//                           </div>
//                           {apiError && (
//                             <div className="error-message-dark mt-2">
//                               {apiError}
//                             </div>
//                           )}
//                         </div>

//                         {/* Search Result */}
//                         {searchResult && (
//                           <div className="search-result-dark">
//                             <div className="account-name-display-dark">
//                               <div className="account-name-label">Account Name:</div>
//                               <div className="account-name-value">{accountName}</div>
//                             </div>
//                             {searchResult.userId && (
//                               <div className="user-id-display mt-2">
//                                 <small className="text-muted">User ID: {searchResult.userId}</small>
//                               </div>
//                             )}
//                           </div>
//                         )}

//                         {/* Amount Section */}
//                         <div className="amount-section-dark">
//                           {activeMode === 'active-id' ? (
//                             <div className="fixed-amount-dark">
//                               <div className="fixed-amount-label">Fixed Transfer Amount</div>
//                               <div className="fixed-amount-value">$5.00</div>
//                               <div className="fixed-amount-note">Active ID transfer amount (Fixed)</div>
//                             </div>
//                           ) : (
//                             <div className="custom-amount-dark">
//                               <label className="custom-amount-label">Enter Amount to Transfer</label>
//                               <div className="amount-input-container">
//                                 <div className="amount-input-group-dark">
//                                   <span className="currency-symbol-dark">$</span>
//                                   <input
//                                     type="number"
//                                     className="amount-input-dark"
//                                     placeholder="0.00"
//                                     min="5"
//                                     max={availableAmount}
//                                     step="0.01"
//                                     value={customAmount}
//                                     onChange={(e) => setCustomAmount(e.target.value)}
//                                     required
//                                     disabled={!searchResult || transferring}
//                                   />
//                                   <span className="currency-label-dark">USD</span>
//                                 </div>
//                                 <div className="amount-limits-dark">
//                                   <span>Min: $5.00</span>
//                                   <span>Available: ${formatAmount(availableAmount)}</span>
//                                   <span>Max: ${formatAmount(availableAmount)}</span>
//                                 </div>
//                               </div>
//                               {customAmount && parseFloat(customAmount) > 0 && (
//                                 <div className="amount-preview mt-3">
//                                   <div className="alert alert-info mb-0">
//                                     You will send <strong>${formatAmount(parseFloat(customAmount))}</strong> to {accountName}
//                                   </div>
//                                 </div>
//                               )}
//                             </div>
//                           )}
//                         </div>

//                         {/* Submit Button */}
//                         <div className="submit-section">
//                           <button 
//                             type="submit" 
//                             className="submit-btn-dark"
//                             disabled={!searchResult || (activeMode === 'send-money' && !customAmount) || transferring || loadingBalance}
//                           >
//                             {transferring ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                 Processing...
//                               </>
//                             ) : (
//                               <>
//                                 <Send size={22} className="me-3" />
//                                 {activeMode === 'active-id' 
//                                   ? 'Transfer $5.00' 
//                                   : `Send $${customAmount ? formatAmount(parseFloat(customAmount)) : '0.00'}`}
//                               </>
//                             )}
//                           </button>
//                           <p className="text-muted text-center mt-3 small">
//                             Transactions are processed instantly and cannot be reversed.
//                           </p>
//                         </div>

//                         {/* Features */}
//                         <div className="features-section mt-4">
//                           <div className="row">
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon secure-feature">
//                                   <Shield size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Secure</div>
//                                   <div className="feature-desc">End-to-end encrypted</div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon fast-feature">
//                                   <Zap size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Instant</div>
//                                   <div className="feature-desc">Processed in seconds</div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon low-feature">
//                                   <DollarSign size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Low Fees</div>
//                                   <div className="feature-desc">Minimum charges</div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default WalletTransfer;
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, User, CheckCircle, Wallet, Send, Copy, Shield, Zap, DollarSign, ChevronUp, ChevronDown } from 'lucide-react';
import '../../Dashboard Style/WalletTransfer.css';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  searchUserByEmailApi,
  activeRegisterUserByWalletApi,
  sendWalletTransferApi,
  getUserWalletBalanceApi
} from '../../Services/Operations/ProductAPI';

const WalletTransfer = () => {
  const navigate = useNavigate();
  const [activeMode, setActiveMode] = useState('active-id');
  const [availableAmount, setAvailableAmount] = useState(0);
  const [activeEmail, setActiveEmail] = useState('');
  const [sendEmail, setSendEmail] = useState('');
  const [customAmount, setCustomAmount] = useState('');
  const [searching, setSearching] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [searchResult, setSearchResult] = useState(null);
  const [accountName, setAccountName] = useState('');
  const [apiError, setApiError] = useState('');
  const [transferring, setTransferring] = useState(false);
  const [loadingBalance, setLoadingBalance] = useState(true);
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };


  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {};
  }, [sidebarOpen]);

  useEffect(() => {
    // Add custom scrollbar styles for sidebar
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    `;
    document.head.appendChild(style);

    // Fetch wallet balance on component mount
    fetchWalletBalance();

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const fetchWalletBalance = async () => {
    try {
      setLoadingBalance(true);
      
      if (userData?.wallets?.main_wallet) {
        setAvailableAmount(parseFloat(userData.wallets.main_wallet));
      } else {
        const result = await getUserWalletBalanceApi(authToken);
        if (result.status) {
          setAvailableAmount(parseFloat(result.data.main_wallet || result.data.balance || 0));
        } else {
          toast.error(result.message || 'Failed to load wallet balance');
        }
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      toast.error('Failed to load wallet balance');
    } finally {
      setLoadingBalance(false);
    }
  };

  const searchUserByEmail = async (email) => {
    try {
      setSearching(true);
      setApiError('');
      
      const result = await searchUserByEmailApi(authToken, email);
      
      if (result.status) {
        const userData = result.data;
        setAccountName(userData.account_name || userData.name || email);
        setSearchResult({
          email: email,
          name: userData.account_name || userData.name || email,
          accountName: userData.account_name,
          userId: userData.id,
          avatarColor: '#00d4aa',
          verified: true
        });
        toast.success('User found successfully!');
        return { success: true, data: userData };
      } else {
        setSearchResult(null);
        setAccountName('');
        setApiError(result.message || 'User not found');
        toast.error(result.message || 'User not found');
        return { success: false, message: result.message };
      }
    } catch (error) {
      console.error('Error searching user:', error);
      setSearchResult(null);
      setAccountName('');
      setApiError('Failed to search user. Please try again.');
      toast.error('Failed to search user. Please try again.');
      return { success: false, message: 'Network error' };
    } finally {
      setSearching(false);
    }
  };

  const handleSearchActiveEmail = async () => {
    if (!activeEmail.trim()) {
      toast.error('Please enter an email address');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(activeEmail)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    await searchUserByEmail(activeEmail);
  };

  const handleSearchSendEmail = async () => {
    if (!sendEmail.trim()) {
      toast.error('Please enter an email address');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(sendEmail)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    await searchUserByEmail(sendEmail);
  };

  const handleActiveIdTransfer = async () => {
    try {
      setTransferring(true);
      
      const result = await activeRegisterUserByWalletApi(authToken, activeEmail);
      
      if (result.status) {
        toast.success(result.message || 'User activated successfully! $5 transferred.');
        fetchWalletBalance();
        setActiveEmail('');
        setSearchResult(null);
        setAccountName('');
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else {
        toast.error(result.message || 'Transfer failed');
      }
    } catch (error) {
      console.error('Error activating user:', error);
      toast.error('Failed to activate user. Please try again.');
    } finally {
      setTransferring(false);
    }
  };

  const handleSendMoneyTransfer = async () => {
    try {
      setTransferring(true);
      
      const result = await sendWalletTransferApi(
        authToken, 
        sendEmail, 
        'FuelWallet',
        customAmount
      );
      
      if (result.status) {
        toast.success(result.message || `$${customAmount} sent successfully!`);
        fetchWalletBalance();
        setSendEmail('');
        setCustomAmount('');
        setSearchResult(null);
        setAccountName('');
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else {
        toast.error(result.message || 'Transfer failed');
      }
    } catch (error) {
      console.error('Error sending money:', error);
      toast.error('Failed to send money. Please try again.');
    } finally {
      setTransferring(false);
    }
  };

  // Function to round to nearest multiple of 5
  const roundToMultipleOf5 = (value) => {
    if (!value || value === '') return '';
    
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    
    // Round to nearest multiple of 5
    const rounded = Math.round(num / 5) * 5;
    
    // Ensure minimum of 5
    return rounded < 5 ? 5 : rounded;
  };

  // Smart amount input handler
  const handleAmountInput = (value) => {
    // Allow empty value
    if (value === '') {
      setCustomAmount('');
      setApiError('');
      return;
    }
    
    // Remove any non-numeric characters except decimal point
    const cleanValue = value.replace(/[^0-9.]/g, '');
    
    // Parse the number
    const num = parseFloat(cleanValue);
    
    if (isNaN(num)) {
      setCustomAmount('');
      setApiError('Please enter a valid number');
      return;
    }
    
    // Auto-round to nearest multiple of 5
    const roundedAmount = roundToMultipleOf5(num);
    
    // Set the rounded value
    setCustomAmount(roundedAmount.toString());
    
    // Validate
    if (roundedAmount < 5) {
      setApiError('Minimum transfer amount is $5');
    } else if (roundedAmount > availableAmount) {
      setApiError('Insufficient funds in your wallet');
    } else {
      setApiError('');
    }
  };

  // Increment/Decrement by 5
  const incrementAmount = () => {
    if (!searchResult || transferring) return;
    
    const current = parseFloat(customAmount) || 0;
    const newAmount = current + 5;
    
    if (newAmount <= calculateMaxAmount()) {
      setCustomAmount(newAmount.toString());
      setApiError('');
    } else {
      setApiError('Cannot exceed available balance');
    }
  };

  const decrementAmount = () => {
    if (!searchResult || transferring) return;
    
    const current = parseFloat(customAmount) || 5;
    const newAmount = current - 5;
    
    if (newAmount >= 5) {
      setCustomAmount(newAmount.toString());
      setApiError('');
    } else {
      setApiError('Minimum amount is $5');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (activeMode === 'active-id') {
      if (!activeEmail.trim()) {
        toast.error('Please enter recipient email');
        return;
      }
      
      if (!searchResult) {
        toast.error('Please search and verify the user first');
        return;
      }
      
      const confirmed = window.confirm(
        `Are you sure you want to activate ${accountName}?\n\n` +
        `Email: ${activeEmail}\n` +
        `Amount: $5.00\n\n` +
        `This action cannot be undone.`
      );
      
      if (confirmed) {
        await handleActiveIdTransfer();
      }
      
    } else {
      if (!sendEmail.trim() || !customAmount) {
        toast.error('Please fill all fields');
        return;
      }
      
      if (!searchResult) {
        toast.error('Please search and verify the user first');
        return;
      }
      
      const amount = parseFloat(customAmount);
      
      if (amount < 5) {
        toast.error('Minimum transfer amount is $5');
        return;
      }
      
      if (amount % 5 !== 0) {
        toast.error('Amount must be a multiple of $5');
        return;
      }
      
      if (amount > availableAmount) {
        toast.error('Insufficient funds in your wallet');
        return;
      }
      
      const confirmed = window.confirm(
        `Are you sure you want to send $${amount.toFixed(2)} to ${accountName}?\n\n` +
        `Email: ${sendEmail}\n` +
        `Amount: $${amount.toFixed(2)}\n` +
        `Available: $${availableAmount.toFixed(2)}\n\n` +
        `This action cannot be undone.`
      );
      
      if (confirmed) {
        await handleSendMoneyTransfer();
      }
    }
  };

  const handleCopyEmail = () => {
    const email = activeMode === 'active-id' ? activeEmail : sendEmail;
    if (email) {
      navigator.clipboard.writeText(email);
      toast.success('Email copied to clipboard!');
    }
  };

  const handleModeChange = (mode) => {
    setActiveMode(mode);
    setSearchResult(null);
    setAccountName('');
    setApiError('');
    if (mode === 'active-id') {
      setSendEmail('');
      setCustomAmount('');
    } else {
      setActiveEmail('');
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // Calculate maximum allowed amount (nearest multiple of 5 <= availableAmount)
  const calculateMaxAmount = () => {
    const max = Math.floor(availableAmount / 5) * 5;
    return max > 0 ? max : 0;
  };

  // Quick amount buttons (5, 10, 20, 50, 100)
  const quickAmounts = [5, 10, 20, 50, 100, 200, 500];

  return (
    <div className="main-wrapper dark-theme">
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                          isOpen={!sidebarOpen}
                          onClose={closeSidebar}
                        />
              
                        {/* Mobile backdrop */}
                        {isMobile && sidebarOpen && (
                          <div
                            className="sidebar-backdrop"
                            onClick={closeSidebar}
                          />
                        )}
             </nav>
       
             <div className="page-wrapper">
               <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
                   isMobile={isMobile}/>
       

        <div className="page-content">
          <div className="wallet-transfer-container-dark">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="" style={{width:"100%"}}>
                  <div className="dark-transfer-card">
                    <div className="dark-balance-section">
                      <div className="balance-card-dark">
                        <div className="balance-content">
                          <div className="balance-label-dark">My Wallet Balance</div>
                          <div className="balance-amount-dark">
                            {loadingBalance ? (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : (
                              `$${formatAmount(availableAmount)}`
                            )}
                          </div>
                          <div className="balance-subtitle-dark">Quantum Main Vault • Ready to Transfer</div>
                        </div>
                        <div className="wallet-icon-dark">
                          <Wallet size={40} />
                        </div>
                      </div>
                    </div>

                    <div className="dark-mode-toggle">
                      <div className="toggle-buttons-dark">
                        <button
                          className={`toggle-btn-dark ${activeMode === 'active-id' ? 'active' : ''}`}
                          onClick={() => handleModeChange('active-id')}
                          disabled={transferring}
                        >
                          <CheckCircle size={20} className="me-3" />
                          <div className="toggle-content">
                            <div className="toggle-title">Active ID Transfer</div>
                            <div className="toggle-subtitle">Fixed $5 amount</div>
                          </div>
                        </button>
                        <button
                          className={`toggle-btn-dark ${activeMode === 'send-money' ? 'active' : ''}`}
                          onClick={() => handleModeChange('send-money')}
                          disabled={transferring}
                        >
                          <Send size={20} className="me-3" />
                          <div className="toggle-content">
                            <div className="toggle-title">Send Money</div>
                            <div className="toggle-subtitle">Multiples of $5 only</div>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div className="dark-form-section">
                      <form onSubmit={handleSubmit}>
                        <div className="form-group-dark">
                          <label className="form-label-dark">
                            <Search size={18} className="me-2" />
                            Search Recipient by Email
                          </label>
                          <div className="search-container-dark">
                            <div className="input-group-dark">
                              <div className="input-icon-dark">
                                <User size={18} />
                              </div>
                              <input
                                type="email"
                                className="dark-input"
                                placeholder="Enter recipient's email address"
                                value={activeMode === 'active-id' ? activeEmail : sendEmail}
                                onChange={(e) => {
                                  if (activeMode === 'active-id') {
                                    setActiveEmail(e.target.value);
                                  } else {
                                    setSendEmail(e.target.value);
                                  }
                                  setSearchResult(null);
                                  setAccountName('');
                                  setApiError('');
                                }}
                                required
                                disabled={transferring}
                              />
                              <button
                                type="button"
                                className="copy-btn-dark"
                                onClick={handleCopyEmail}
                                disabled={(!activeEmail && !sendEmail) || transferring}
                                title="Copy email"
                              >
                                <Copy size={16} />
                              </button>
                            </div>
                            <button
                              type="button"
                              className="search-btn-dark"
                              onClick={activeMode === 'active-id' ? handleSearchActiveEmail : handleSearchSendEmail}
                              disabled={searching || transferring}
                            >
                              {searching ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2"></span>
                                  Searching...
                                </>
                              ) : (
                                <>
                                  <Search size={16} className="me-2" />
                                  Search
                                </>
                              )}
                            </button>
                          </div>
                          {apiError && (
                            <div className="error-message-dark mt-2">
                              {apiError}
                            </div>
                          )}
                        </div>

                        {searchResult && (
                          <div className="search-result-dark">
                            <div className="account-name-display-dark">
                              <div className="account-name-label">Account Name:</div>
                              <div className="account-name-value">{accountName}</div>
                            </div>
                            {searchResult.userId && (
                              <div className="user-id-display mt-2">
                                <small className="text-muted">User ID: {searchResult.userId}</small>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="amount-section-dark">
                          {activeMode === 'active-id' ? (
                            <div className="fixed-amount-dark">
                              <div className="fixed-amount-label">Fixed Transfer Amount</div>
                              <div className="fixed-amount-value">$5.00</div>
                              <div className="fixed-amount-note">Active ID transfer amount (Fixed)</div>
                            </div>
                          ) : (
                            <div className="custom-amount-dark">
                              <label className="custom-amount-label">Enter Amount to Transfer</label>
                              
                              {/* Quick Amount Buttons */}
                              {/* {searchResult && !transferring && ( */}
                                <div className="quick-amounts-container mb-3">
                                  <div className="quick-amounts-label">Quick Select:</div>
                                  <div className="quick-amounts-buttons">
                                    {quickAmounts.map(amount => {
                                      if (amount % 5 === 0 && amount <= calculateMaxAmount()) {
                                        return (
                                          <button
                                            key={amount}
                                            type="button"
                                            className={`quick-amount-btn ${parseFloat(customAmount) === amount ? 'active' : ''}`}
                                            onClick={() => setCustomAmount(amount.toString())}
                                          >
                                            ${amount}
                                          </button>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                </div>
                              {/* )} */}
                              
                              <div className="amount-input-container">
                                <div className="amount-input-group-dark">
                                  <span className="currency-symbol-dark">$</span>
                                  <input
                                    type="text"
                                    className="amount-input-dark"
                                    placeholder="0.00"
                                    value={customAmount}
                                    onChange={(e) => handleAmountInput(e.target.value)}
                                    onBlur={(e) => {
                                      if (e.target.value && e.target.value !== '') {
                                        const rounded = roundToMultipleOf5(e.target.value);
                                        setCustomAmount(rounded.toString());
                                      }
                                    }}
                                    required
                                    disabled={!searchResult || transferring}
                                  />
                                  <span className="currency-label-dark">USD</span>
                                  <div className="amount-stepper">
                                    <button
                                      type="button"
                                      className="step-btn step-up"
                                      onClick={incrementAmount}
                                      disabled={!searchResult || transferring || parseFloat(customAmount || 0) >= calculateMaxAmount()}
                                    >
                                      <ChevronUp size={14} />
                                    </button>
                                    <button
                                      type="button"
                                      className="step-btn step-down"
                                      onClick={decrementAmount}
                                      disabled={!searchResult || transferring || parseFloat(customAmount || 5) <= 5}
                                    >
                                      <ChevronDown size={14} />
                                    </button>
                                  </div>
                                </div>
                                <div className="amount-limits-dark">
                                  <span>Min: $5.00</span>
                                  <span>Available: ${formatAmount(availableAmount)}</span>
                                  <span>Max: ${formatAmount(calculateMaxAmount())}</span>
                                </div>
                                <div className="amount-rules mt-2">
                                  <small className="text-info">
                                    <i className="bi bi-info-circle me-1"></i>
                                    Amount will be auto-adjusted to nearest multiple of $5
                                  </small>
                                </div>
                              </div>
                              
                              {customAmount && parseFloat(customAmount) > 0 && (
                                <div className="amount-preview mt-3">
                                  <div className={`alert ${parseFloat(customAmount) % 5 === 0 && parseFloat(customAmount) <= availableAmount ? 'alert-info' : 'alert-warning'} mb-0`}>
                                    {parseFloat(customAmount) % 5 === 0 && parseFloat(customAmount) <= availableAmount ? (
                                      <>
                                        You will send <strong>${formatAmount(parseFloat(customAmount))}</strong> to {accountName}
                                      </>
                                    ) : (
                                      <>
                                        Amount adjusted to <strong>${formatAmount(roundToMultipleOf5(customAmount))}</strong> (nearest multiple of $5)
                                      </>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="submit-section">
                          <button 
                            type="submit" 
                            className="submit-btn-dark"
                            disabled={
                              !searchResult || 
                              transferring || 
                              loadingBalance ||
                              (activeMode === 'send-money' && (!customAmount || parseFloat(customAmount) < 5 || parseFloat(customAmount) % 5 !== 0))
                            }
                          >
                            {transferring ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Processing...
                              </>
                            ) : (
                              <>
                                <Send size={22} className="me-3" />
                                {activeMode === 'active-id' 
                                  ? 'Transfer $5.00' 
                                  : `Send $${customAmount ? formatAmount(parseFloat(customAmount)) : '0.00'}`}
                              </>
                            )}
                          </button>
                          <p className="text-muted text-center mt-3 small">
                            {activeMode === 'send-money' 
                              ? 'Amounts are automatically adjusted to multiples of $5. Transactions are processed instantly.' 
                              : 'Transactions are processed instantly and cannot be reversed.'}
                          </p>
                        </div>

                        <div className="features-section mt-4">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <div className="feature-item">
                                <div className="feature-icon secure-feature">
                                  <Shield size={20} />
                                </div>
                                <div className="feature-content">
                                  <div className="feature-title">Secure</div>
                                  <div className="feature-desc">End-to-end encrypted</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="feature-item">
                                <div className="feature-icon fast-feature">
                                  <Zap size={20} />
                                </div>
                                <div className="feature-content">
                                  <div className="feature-title">Instant</div>
                                  <div className="feature-desc">Processed in seconds</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="feature-item">
                                <div className="feature-icon low-feature">
                                  <DollarSign size={20} />
                                </div>
                                <div className="feature-content">
                                  <div className="feature-title">Structured</div>
                                  <div className="feature-desc">Multiples of $5 only</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="footer-dark">
          <div className="container">
            <p className="text-center mb-0">
              Copyright © 2025 Willow Quantum. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default WalletTransfer;